import { BrandLogoEntity } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import {
  RoomBrandLogoCreate2VO,
  RoomBrandLogoDeleteVO,
  RoomBrandLogoUnUseVO,
  RoomBrandLogoUseVO
} from "@youm-front/room/domain";

export const roomBrandLogoCreate = createAction(
  "[Room] Room Brand Logo Create",
  props<{ roomBrandLogoCreateVO: RoomBrandLogoCreate2VO }>()
);
export const roomBrandLogoCreateSuccess = createAction(
  "[Room] Room Brand Logo Create Success",
  props<{ brandLogo: BrandLogoEntity }>()
);
export const roomBrandLogoCreateFailure = createAction(
  "[Room] Room Brand Logo Create Failure",
  props<{ error: string }>()
);

export const roomBrandLogoDelete = createAction(
  "[Room] Room Brand Logo Delete",
  props<{ roomBrandLogoDeleteVO: RoomBrandLogoDeleteVO }>()
);
export const roomBrandLogoDeleteSuccess = createAction(
  "[Room] Room Brand Logo Delete Success",
  props<{ brandLogo: BrandLogoEntity }>()
);
export const roomBrandLogoDeleteFailure = createAction(
  "[Room] Room Brand Logo Delete Failure",
  props<{ error: string }>()
);

export const roomBrandLogoUnUse = createAction(
  "[Room] Room Brand Logo Un Use",
  props<{ roomBrandLogoUnUseVO: RoomBrandLogoUnUseVO }>()
);
export const roomBrandLogoUnUseSuccess = createAction(
  "[Room] Room Brand Logo Un Use Success",
  props<{ brandLogo: BrandLogoEntity }>()
);
export const roomBrandLogoUnUseFailure = createAction(
  "[Room] Room Brand Logo Un Use Failure",
  props<{ error: string }>()
);

export const roomBrandLogoUse = createAction(
  "[Room] Room Brand Logo Use",
  props<{ roomBrandLogoUseVO: RoomBrandLogoUseVO }>()
);
export const roomBrandLogoUseSuccess = createAction(
  "[Room] Room Brand Logo Use Success",
  props<{ brandLogo: BrandLogoEntity }>()
);
export const roomBrandLogoUseFailure = createAction(
  "[Room] Room Brand Logo Use Failure",
  props<{ error: string }>()
);
